import * as React from "react"
const SvgCloudUpload = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M6.5 20.857q-2.275 0-3.888-1.575T1 15.432q0-1.95 1.175-3.475c1.175-1.525 1.808-1.667 3.075-1.95q.625-2.3 2.5-3.725T12 4.857q2.925 0 4.962 2.038Q19.001 8.932 19 11.857q1.725.201 2.863 1.488A4.4 4.4 0 0 1 23 16.357q0 1.875-1.313 3.188c-1.313 1.313-1.937 1.312-3.187 1.312zm3.6-6.275.9-.875v5.15H6.5a3.37 3.37 0 0 1-2.475-1.025A3.37 3.37 0 0 1 3 15.357q0-1.449 1.025-2.475A3.37 3.37 0 0 1 6.5 11.857H7Q7 9.782 8.463 8.32 9.925 6.857 12 6.857c2.075 0 2.563.488 3.537 1.463Q17 9.782 17 11.857v2h1.5q1.05 0 1.775.725T21 16.357c0 1.05-.242 1.292-.725 1.775q-.725.725-1.775.725H13v-5.15l.9.875q.3.275.713.263a.98.98 0 0 0 .687-.288.93.93 0 0 0 .287-.712.98.98 0 0 0-.287-.688l-2.6-2.6a.96.96 0 0 0-.7-.3q-.4 0-.7.3l-2.6 2.6a.95.95 0 0 0-.275.7q0 .426.275.7.3.3.713.3a.93.93 0 0 0 .687-.275"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgCloudUpload
